import { lazy, Suspense, use, useEffect, useState } from 'react';
import { MeContext } from '../../contexts/me.context';

const SwitchLocationsModal = lazy(() => import('./SwitchLocationsModal'));

const SwitchLocations = () => {
  const { activeLocations } = use(MeContext);

  const [switchLocationsModalOpen, setSwitchLocationsModalOpen] = useState<boolean>(false);

  // Listen for global location switcher custom event
  useEffect(() => {
    const handleOpenLocationSwitcher = () => {
      if (activeLocations?.length > 1) {
        setSwitchLocationsModalOpen(true);
      }
    };

    document.addEventListener('openLocationSwitcher', handleOpenLocationSwitcher);

    return () => {
      document.removeEventListener('openLocationSwitcher', handleOpenLocationSwitcher);
    };
  }, [activeLocations]);

  // Direct keyboard shortcut for location switcher. Keep form fields and
  // editable content exempt so typing never opens the modal.
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement | null;
      const isFormInput = !!target?.closest(
        'input, textarea, select, [contenteditable]:not([contenteditable="false"])'
      );

      if (
        !isFormInput &&
        event.ctrlKey &&
        event.shiftKey &&
        event.key.toLowerCase() === 'l' &&
        activeLocations?.length > 1
      ) {
        event.preventDefault();
        setSwitchLocationsModalOpen(true);
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [activeLocations]);

  return (
    <>
      {activeLocations?.length > 1 && (
        <div
          onClick={() => {
            setSwitchLocationsModalOpen(true);
          }}
          className="text-primary-600 hover:text-primary-400 dark:text-dark-gray-400 dark:hover:text-dark-gray-50  cursor-pointer leading-4 text-xs"
        >
          Change location
        </div>
      )}
      {switchLocationsModalOpen && (
        <Suspense fallback={null}>
          <SwitchLocationsModal close={() => setSwitchLocationsModalOpen(false)} />
        </Suspense>
      )}
    </>
  );
};

export default SwitchLocations;
